export default {
  general: {
    getState: '/v1/general/states',
  },
  auth: {
    sendOtp: "/v1/users/auth/get-otp",
    verifyOtp: "/v1/users/auth/verify-otp",
    register: "v1/users/auth/register-user",
    // logout: "/v1/users/auth/logout",
    logout: "/v1/admin/auth/logout",
    verifyPassword: "/v1/users/auth/verify-password",
    login: "/v1/admin/auth/login",
  },
  // company: {
  //   addCompany: "/v1/admin/general/add-company",
  //   getCompanyList: "/v1/admin/general/list-company",
  // },
  // department: {
  //   addDepartment: "/v1/admin/general/add-department",
  //   getDepartmentList: "/v1/admin/general/list-department",
  //   addSubDepartment: "/v1/admin/general/add-sub-department",
  //   getSubDepartmentList: "/v1/admin/general/list-sub-department/",
  //   updateDepartment: "/v1/admin/general/update-department/",
  //   deleteDepartment: "/v1/admin/general/delete-department/",
  //   updateSubDepartment: "/v1/admin/general/update-sub-department/",
  //   deleteSubDepartment: "/v1/admin/general/delete-sub-department/",
  //   uploadPolicyFile: "/v1/admin/general/upload-file",
  // },
  // designation: {
  //   addDesignation: "/v1/admin/general/add-designation",
  //   getDesignationList: "/v1/admin/general/list-designation",
  //   updateDesignation: "/v1/admin/general/update-designation/",
  //   deleteDesignation: "/v1/admin/general/delete-designation/",
  // },
  // krakpi: {
  //   addUpdateKRAKPI: "/v1/admin/general/add-update",
  //   getAddUpdatePolicy: "/v1/general/get-add-update-policy",
  //   uploadFile: "/v1/admin/category/uploadImage",
  // },
  admin: {
    addAgeGroup: "/v1/admin/category/add-ageGroup",
    getAgeGroupList: "/v1/admin/category/list-ageGroup",
    addProductType: "/v1/admin/category/add-productType",
    updateAgeGroup: "/v1/admin/category/update-ageGroup/",
    deleteAgeGroup: "/v1/admin/category/delete-ageGroup/",
    getProductTypeList: "/v1/admin/category/get-productType",
    addCategory: "v1/admin/category/add-category",
    updateProductType: "/v1/admin/category/update-productType/",
    deleteProductType: "/v1/admin/category/delete-productType/",
    getCategoryList: "/v1/admin/category/list",
    addSubCategory: "/v1/admin/category/add-sub-category",
    addTagOption: "/v1/admin/category/add-Tag",
    getTagOptionList: "/v1/admin/category/get-Tag",
    addProduct: "/v1/admin/product/add-product",
    getLanguageList: "v1/category/get-language",
    getSubCategoryList: "/v1/admin/category/list-sub-category",
    getProductList: "/v1/admin/product/list-product",
    addBlog: "v1/admin/blog/addBlog",
    getGSTList: "/v1/general/GSTPercentage",
    getGeneralProductType: "v1/admin/general/get-productType",
    addBaseOffer: "/v1/admin/baseOffer/add-BaseOffer",
    getBaseOfferList: "/v1/admin/baseOffer/list-BaseOffers",
    deleteBaseOffer: "/v1/admin/baseOffer/delete-BaseOffer/",
    updateCategory: "/v1/admin/category/update/",
    deleteCategory: "/v1/admin/category/delete/",
    updateTagOption: "/v1/admin/category/update-Tag/",
    deleteTagOption: "/v1/admin/category/delete-Tag/",
    getBlogList: "/v1/admin/blog/getBlog",
    deleteProduct: "/v1/admin/product/delete-product/",
    getProductById: "/v1/admin/product/get-product/",
    updateProduct: "/v1/admin/product/update-product/",
    getCouponType: "/v1/admin/general/get-couponType",
    createCouponCode: "/v1/admin/coupon/add-coupon",
    createAuthor: "/v1/admin/author/add",
    getAuthorList: "/v1/admin/author/get-list",
    getCouponCodeList: "/v1/admin/coupon/list-Coupons",
    getCouponCodeById: "/v1/admin/coupon/get-Coupon/",
    getAuthorDetailsById: "/v1/admin/author/get-details/",
    updateAuthor: "/v1/admin/author/update-author/",
    deleteAuthor: "/v1/admin/author/delete-author/",
    getBlogDetailsById: "/v1/admin/blog/fetch/",
    updateBlog: "/v1/admin/blog/updateBlog/",
    deleteBlog: "/v1/admin/blog/deleteBlog/",
    deleteCouponCode: "/v1/admin/coupon/delete-coupon/",
    updateCouponCode: "/v1/admin/coupon/update-Coupon/",
    getRoleList: "/v1/admin/general/get-roles",
    createUser: "/v1/admin/auth/add-admin-user-with-role",
    getBaseOfferById: "/v1/admin/baseOffer/get-BaseOffer/",
    updateBaseOffer: "/v1/admin/baseOffer/update-BaseOffer/",
    getSellingSource: "/v1/admin/source/list",
    uploadAgeGroupImage: "/v1/admin/category/upload-ageGroup",
    uploadProductTypeImage: "/v1/admin/category/upload-productType",
    uploadCategoryImage: "/v1/admin/category/upload-category",
    uploadAutorImage: "/v1/admin/author/upload",
    uploadBlogImage: "/v1/admin/blog/uploadImage",
    uploadMedia: "/v1/admin/product/upload-media",
    uploadCategoryVideo: "v1/admin/category/upload-video",
    addCategoryVideo: "v1/admin/category/add-CategoryVideo",
    updateCategoryVideo: "v1/admin/category/update-CategoryVideo/",
    getCategoryVideoListById: "v1/admin/category/get-CategoryVideoList/",
    getCategoryVideoById: "v1/admin/category/get-CategoryVideo/",
    deleteCategoryVideo: "v1/admin/category/delete-CategoryVideo/",
    booksAnswerkeyUpload:"/v1/admin/product/upload-answerkey"
  },
  cxo: {
    getTransactionDetails: "/v1/admin/transaction/getOrders",
    getSourceWiseAnalysis: "/v1/admin/transaction/sourcewise-revenue",
    getCouponTypeList: "v1/admin/general/get-couponType",
    getStateWiseAnalysis: "/v1/admin/transaction/statewise-revenue",
    getProductWiseRevenue: '/v1/admin/transaction/productwise-revenue',
    getAllSourceLeads: "/v1/admin/leads/get",
    getSourceWiseUserCount: '/v1/admin/leads/getSourceWiseUserCount',
    getStateWiseUserCount: '/v1/admin/leads/getStateWiseUserCount',
    getSourceWiseRevenueAnalysis: "/v1/inventory/source-wise-revenue",
    getSellingSourceWiseAnalysis: "/v1/inventory/source-wise-analysis",
    getStockAnalysis: "/v1/inventory/stock-analysis",

  },
  publication: {
    addSellingSource: "/v1/admin/source/add",
    getSellingSourceList: "/v1/admin/source/get",
    updateSellingSource: "/v1/admin/source/update/",
    deleteSellingSource: "/v1/admin/source/delete/",
    addTds: "/v1/admin/tds-section/add",
    getTdsList: "/v1/admin/tds-section/get",
    updateTds: "/v1/admin/tds-section/update/",
    deleteTds: "/v1/admin/tds-section/delete/",
    vendorList: "/v1/admin/vendor/get",
    addVendor: "/v1/admin/vendor/add",
    getstate: "/v1/general/states",
    getCities: "/v1/general/cities/",
    getTDSSectionList: "/v1/admin/tds-section/list",
    deleteVendor: "/v1/admin/vendor/delete/",
    updateVendor: "/v1/admin/vendor/update/",
    getOrdersList: "/v1/admin/orders/list",
    addShipment: "/v1/admin/orders/add-shipment",
    updateShipment: "/v1/admin/orders/update-shipment/",
    scanProduct: "/v1/inventory/scan-product/",
    addStock: "/v1/inventory/add-stock",
    returnStock: "/v1/inventory/return-stock",
    transferStock: "/v1/inventory/transfer-stock",
    sellStock: "/v1/inventory/sell-stock",
    uploadInvoice: "/v1/inventory/upload-invoice",
    productHistory: "/v1/inventory/products-history",
    productHistoryDetails: "/v1/inventory/product-history",
    getDamageStock: "/v1/inventory/damage-stock",
    uploadStockImage: "/v1/inventory/upload-stock-image",
  },
  superAdmin: {
    manageEmployee: {
      getEmployeeList: "/v1/admin/employee/list-employee",
      addEmployee: "/v1/admin/employee/add-employee",
      uploadEmplyeeFile: "/v1/admin/employee/upload-file",
      getManagerList: "/v1/admin/employee/get-manager-list"
    },
    company: {
      addCompany: "/v1/admin/general/add-company",
      getCompanyList: "/v1/admin/general/list-company",
    },
    department: {
      addDepartment: "/v1/admin/general/add-department",
      getDepartmentList: "/v1/admin/general/list-department",
      addSubDepartment: "/v1/admin/general/add-sub-department",
      getSubDepartmentList: "/v1/admin/general/list-sub-department/",
      updateDepartment: "/v1/admin/general/update-department/",
      deleteDepartment: "/v1/admin/general/delete-department/",
      updateSubDepartment: "/v1/admin/general/update-sub-department/",
      deleteSubDepartment: "/v1/admin/general/delete-sub-department/",
      uploadPolicyFile: "/v1/admin/general/upload-file",
    },
    designation: {
      addDesignation: "/v1/admin/general/add-designation",
      getDesignationList: "/v1/admin/general/list-designation",
      updateDesignation: "/v1/admin/general/update-designation/",
      deleteDesignation: "/v1/admin/general/delete-designation/",
    },
    krakpi: {
      addUpdateKRAKPI: "/v1/admin/general/add-update",
      getAddUpdatePolicy: "/v1/general/get-add-update-policy",
      uploadFile: "/v1/admin/category/uploadImage",
    },
    policy: {
      addPolicy: "/v1/admin/general/policy-add",
    },
  },
};